import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/Articles.css';
const ArticleDisplayPage = () => {
  const location = useLocation();
  const { articleId } = location.state || {};
///........
  const [article, setArticle] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (articleId) {
      fetchArticle(articleId);
    }
  }, [articleId]);

  const fetchArticle = async (id) => {
    try {
      // console.log('Fetching article with ID:', id);
      const response = await fetch(`/api/articles/${id}`);  
      if (response.ok) {
        const data = await response.json();
        // console.log('Article data:', data);
        setArticle(data);
      } else {
        // console.log('Article not found');
        setError('Article not found');
      }
    } catch (err) {
      // console.error('Error fetching article:', err);
      setError('Error fetching article');
    }
  };
  
  return (
    <div >
      {error ? (
        <h1 className='articlnotfound'>{error}</h1>
      ) : article ? (
        <>
          <h2 className='article-name'>{article.article_name}</h2>
          <h1 className='article-heading'>{article.article_Heading}</h1>
          {/* <p>{article.article_content}</p> */}
          <div className='paragraph'>
          <p>{article.p1}</p>
          <p>{article.p2}</p>
          <p>{article.p3}</p>
          <p>{article.p4}</p>
          <p>{article.p5}</p>
          <p>{article.p6}</p>
          <p>{article.p7}</p>
          <p>{article.p8}</p>
          <p>{article.p9}</p> 
          <p>{article.p10}</p>
          <p>{article.p11}</p>
          <p>{article.p12}</p>
          <p>{article.p13}</p>
          <p>{article.p14}</p> 
          <p>{article.p15}</p>
          <p>{article.p16}</p>
          <p>{article.p17}</p>
          <p>{article.p18}</p>
          <p>{article.p19}</p>
          <p>{article.p20}</p> 
           </div>
                </>
      ) : (
        <h1>Loading...</h1>
      )}
    </div>
  );
};

export default ArticleDisplayPage;
